import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd-mobile';
import {
    ScheduleOutlined
} from '@ant-design/icons';

import moment from 'moment-timezone';
import 'moment/locale/ru';

import FormRegister from '../../../desktop/components/FormRegister'
import { CollectionServerMobile, errorCatch, GET, IfElse, POST, publish, QueryOrder, QueryParam, updateArrayInArray, useAuth } from 'fennec-ui'


export default function StatusBlock(props) {
    const dispatch = useDispatch();
    const auth = useAuth();
    const { status, filters, compact, uuid } = props;
    const meta = useSelector(state => state.meta);
    const [readallspin, setReadallspin] = useState(false);
    const [spin, setSpin] = useState({});
    const prochitano = status.filter(s => s.tipNovayaInfa).length > 0;

    const action = (status, document, values, unlock, close, { collection, setCollection }) => {
        setSpin({ ...spin, [status.ID]: true })

        POST(auth, `/api/status`, {
            status: status,
            button: document,
            document: values
        }, ({ data }) => {
            if (data.status) {
                setCollection(updateArrayInArray(collection, data.status))
                publish(`service.status.${uuid}`, [...data.status])
            }
            if (close) {
                close();
            }
            setSpin({ ...spin, [status.ID]: false });
        }, errorCatch);

        if (unlock) {
            unlock();
        }
    };
    const markAsReaded = (collection, setCollection) => {
        setReadallspin(true);
        var arr = collection.filter(s => s.tipNovayaInfa);
        if (arr.length > 0) {
            GET(auth, `/api/status/read-all`,
                ({ data }) => {
                    setCollection([])
                    // publish(`service.status.${uuid}`, [])
                    publish(`service.status.clear`, [])
                    setReadallspin(false);
                }, errorCatch);
        }
    };
    const date = (item) => {
        if (item && item.status && item.status.dataPoslednegoIzmeneniya) {
            var time = moment(item.status.dataPoslednegoIzmeneniya).tz("Europe/Moscow").format('DD.MM.YYYY HH:mm');
            if (item.tipNovayaInfa) {
                return (
                    <div style={{
                        color: "rgba(0, 0, 0, 0.65)",
                        fontSize: "12px", marginTop: "3px", fontWeight: "600", cursor: "pointer"
                    }}>{time}</div>
                );
            } else {
                return (
                    <div style={{
                        color: "rgba(0, 0, 0, 0.65)",
                        fontSize: "12px", marginTop: "3px"
                    }}>{time}</div>
                );
            }
        }
    };
    const getFormForItem = (item) => {
        if (item.tipKnopkaPodtverditDokument) {
            return FormRegister(item.tipKnopkaPodtverditDokument);
        }
        if (item.tipKnopkaOtkazatsyaDokument) {
            return FormRegister(item.tipKnopkaOtkazatsyaDokument);
        }
        if (item.tipKnopkaViitiDokument) {
            return FormRegister(item.tipKnopkaViitiDokument);
        }
        if (item.tipKnopkaOKDokument) {
            return FormRegister(item.tipKnopkaOKDokument);
        }
        return undefined;
    };
    const ui = (item, collection, setCollection) => {
        var actionForm = getFormForItem(item);
        // if(!actionForm){
        //     console.error("Не найдена форма ", item.tipKnopkaPodtverditDokument || 
        //     item.tipKnopkaOtkazatsyaDokument || 
        //     item.tipKnopkaViitiDokument || 
        //     item.tipKnopkaOKDokument);
        // }
        return (
            <div key={item.ID}>
                <div style={{ margin: "0 10px", flexBasis: "85px", color: "rgba(0, 0, 0, 0.45)" }}>{date(item)}</div>
                {!item.tipNovayaInfa && <div style={{ margin: "0 10px", flexBasis: "100%", fontSize: "14px" }}>{item.tekstStatusa}</div>}
                {item.tipNovayaInfa && <div
                    style={{ margin: "0 10px", flexBasis: "100%", fontWeight: "600", cursor: "pointer", fontSize: "14px" }}
                // onClick={() => action(item, "read", undefined, undefined, undefined, { collection, setCollection })}
                >{item.tekstStatusa}</div>}
            </div>
        );
    };
    return (

        <CollectionServerMobile
            // onCollectionChange={(collection) => {
            //     publish(`service.status.${uuid}`, [...collection])
            //     console.log("publish",`service.status.${uuid}`);
            // }}
            subscribe={{
                name: "service.status",
                filter: `service.status.${uuid}`,
                func: (data, { msg, collection, setCollection, setCollectionItem, removeCollectionItem, request, state }) => {
                    request()
                }
            }}
            noheader={true}
            name={"InterfeisiInfrastrukturnikhStatusov"}
            auth={auth}
            size="small"
            source={'/api/query/InterfeisiInfrastrukturnikhStatusov'}
            contextFilters={() => [
                QueryOrder("TipNovayaInfa", "DESC"),
                QueryOrder("status.DataPoslednegoIzmeneniya", "DESC"),
                QueryParam("w-status.Arkhiv", "false"),
                IfElse(compact, QueryParam("w-TipNovayaInfa", "true"), undefined),
            ]}
            filters={filters}
            mode={"list"}
            render={(item, idx, { collection, setCollection, setCollectionItem, update }) => {
                return ui(item, collection, setCollection)
            }}
            collectionActions={() => [{
                mode: "func",
                trigger: (click) => (
                    <Button loading={readallspin} style={{ border: "none" }} size="small" onClick={click}><ScheduleOutlined /></Button>
                ),
                action: (values, unlock, close, { collection, setCollection }) => {
                    markAsReaded(collection, setCollection)
                },
            }]}
            modelActionsTitle={(item) => ({
                header: "Выберите действие",
                // subheader: (item) ? item.nazvanieMeropriyatiya : "",
            })}
            modelActions={(item) => {
                var actionForm = getFormForItem(item);
                return [
                    ...IfElse(!!item.tipKnopkaPodtverdit, [{
                        ...props,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaPodtverditDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                        callback: () => {
                            // request
                        },
                        title: item.tipKnopkaPodtverdit,
                        form: actionForm,
                        document: item.tipKnopkaPodtverditDokument.toLowerCase()
                    }], []),
                    ...IfElse(!!item.tipKnopkaOtkazatsya, [{
                        ...props,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaOtkazatsyaDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                        callback: () => {
                            // request
                        },
                        title: item.tipKnopkaOtkazatsya,
                        form: actionForm,
                        document: item.tipKnopkaOtkazatsyaDokument.toLowerCase()
                    }], []),
                    ...IfElse(!!item.tipKnopkaViiti, [{
                        ...props,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaViitiDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                        callback: () => {
                            // request
                        },
                        title: item.tipKnopkaViiti,
                        form: actionForm,
                        document: item.tipKnopkaViitiDokument.toLowerCase()
                    }], []),
                    ...IfElse(!!item.tipKnopkaOK, [{
                        ...props,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => action(item, item.tipKnopkaOKDokument, values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                        callback: () => {
                            // request
                        },
                        title: item.tipKnopkaOK,
                        form: actionForm,
                        document: item.tipKnopkaOKDokument.toLowerCase()
                    }], []),
                    ...IfElse(!!item.tipNovayaInfa, [{
                        ...props,
                        auth: auth,
                        mode: "MenuItem",
                        object: item,
                        action: (values, unlock, close, { collection, setCollection }) => action(item, "read", values, unlock, (!actionForm) ? () => { } : close, { collection, setCollection }),
                        title: "Отметить как прочитанное",
                        form: actionForm,
                        document: "read"
                    }], []),
                ]
            }}
        />
    );
}
